import { IDashboardResponse } from "../../../model/official-daily/response/dashboard-response";
import { IListDocumentTypesResponse } from "../../../model/official-daily/response/list-document-types-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";

const defaultPath = 'Base';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.officialDailyUrl;

const listDocumentTypes = async (): Promise<IListDocumentTypesResponse[]> => {
    return await HttpClient.executeRequest({
        baseURL: baseUrl,
        method: 'get',
        url: `/${defaultPath}/documentTypes`
    }).then((response) => Object.assign([] as unknown as IListDocumentTypesResponse, response.data));
};


const getDashboard = async (): Promise<IDashboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/dashboard`
    }).then((response) => Object.assign({} as unknown as IDashboardResponse, response.data));
};

const BaseAppService = {
    listDocumentTypes, getDashboard
};

export default BaseAppService;